import Api from './api';

const VeiculosService = {
    cadastro: async (params) => {
        const response = await Api.post('/restrito/veiculos/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/restrito/veiculos/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    deletar: (id) => {
        Api.delete(`/restrito/veiculos/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    veiculoEdit: async (id) => {
        const response = await Api.get(`/restrito/veiculos/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/restrito/veiculos/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/restrito/veiculos/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    }
}

export default VeiculosService;